module.exports = "/img/item-11.f56b3a2b.png";